export const endpoints = {
  companies: {
    getByUsername: (username: string) => `/api/v1/internal/companies/user/${username}`,
    getByShortname: (shortname: string) => `/api/v1/internal/companies/${shortname}`
  },

  settings: {
    getSettings: (shortname: string) => `/api/v1/internal/companies/${shortname}/settings`,
    setSetting: (shortname: string) => `/api/v1/internal/companies/${shortname}/settings`
  }
};
